var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 36,
    height: 24,
    rx: 5.5,
    fill: "#F6F7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5117 16.165L14.9751 7.91504H17.2617L15.844 16.165H13.5117Z",
    fill: "#015898"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5117 16.165L15.3867 7.91504H17.2617L15.844 16.165H13.5117Z",
    fill: "#015898"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0117 8.26241C23.5705 8.08872 22.8647 7.91504 21.9823 7.91504C19.7764 7.91504 18.1882 9.00057 18.1882 10.5637C18.1882 11.7361 19.2911 12.344 20.1735 12.7348C21.0558 13.1256 21.3205 13.3861 21.3205 13.7335C21.3205 14.2545 20.6147 14.515 19.997 14.515C19.1147 14.515 18.6294 14.3848 17.8794 14.0808L17.5705 13.9506L17.2617 15.7308C17.7911 15.9479 18.7617 16.165 19.7764 16.165C22.1147 16.165 23.6588 15.0795 23.6588 13.4295C23.6588 12.5177 23.0852 11.8229 21.7617 11.2585C20.9676 10.8677 20.4823 10.6506 20.4823 10.2598C20.4823 9.91241 20.8794 9.56504 21.7617 9.56504C22.5117 9.56504 23.0411 9.6953 23.4382 9.86899L23.6588 9.95583L24.0117 8.26241V8.26241Z",
    fill: "#015898"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0117 8.26241C23.5705 8.08872 22.8647 7.91504 21.9823 7.91504C19.7764 7.91504 18.5852 9.00057 18.5852 10.5637C18.5852 11.7361 19.2911 12.344 20.1735 12.7348C21.0558 13.1256 21.3205 13.3861 21.3205 13.7335C21.3205 14.2545 20.6147 14.515 19.997 14.515C19.1147 14.515 18.6294 14.3848 17.8794 14.0808L17.5705 13.9506L17.2617 15.7308C17.7911 15.9479 18.7617 16.165 19.7764 16.165C22.1147 16.165 23.6588 15.0795 23.6588 13.4295C23.6588 12.5177 23.0852 11.8229 21.7617 11.2585C20.9676 10.8677 20.4823 10.6506 20.4823 10.2598C20.4823 9.91241 20.8794 9.56504 21.7617 9.56504C22.5117 9.56504 23.0411 9.6953 23.4382 9.86899L23.6588 9.95583L24.0117 8.26241V8.26241Z",
    fill: "#015898"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6614 8.51087C26.8881 7.96087 27.2961 7.91504 27.84 7.91504H29.6079L31.5117 16.165H29.3359L29.0639 14.79H26.1628L25.7095 16.165H23.2617L26.6614 8.51087ZM27.704 10.9859C27.704 10.9859 26.9334 13.0025 26.7974 13.415V13.4609H28.7013C28.6106 13.0025 28.1573 10.94 28.1573 10.94L28.0213 10.1609C27.8853 10.4817 27.704 10.9859 27.704 10.9859Z",
    fill: "#015898"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2054 8.51087C27.432 7.96087 27.84 7.91504 28.384 7.91504H29.6079L31.5117 16.165H29.3359L29.0639 14.79H26.1628L25.7095 16.165H23.2617L27.2054 8.51087ZM27.704 10.9859C27.704 10.9859 26.9788 12.9567 26.7974 13.415V13.4609H28.7013C28.6106 13.0025 28.1573 10.94 28.1573 10.94L28.0213 10.1609C27.8853 10.4817 27.704 10.9859 27.704 10.9859Z",
    fill: "#015898"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44922 13.6442L9.22005 12.4525C8.80755 11.0775 7.47839 9.56504 6.01172 8.83171L8.07422 16.165H10.5492L14.2617 7.91504H11.7867L9.44922 13.6442Z",
    fill: "#015898"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44922 13.6442L9.22005 12.4525C8.80755 11.0775 7.47839 9.56504 6.01172 8.83171L8.07422 16.165H10.5492L14.2617 7.91504H12.2451L9.44922 13.6442Z",
    fill: "#015898"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01172 7.91504L3.4147 8.00504C6.28038 8.68004 8.25052 10.39 9.01172 12.415L8.20575 8.59004C8.07142 8.05004 7.66844 7.91504 7.1759 7.91504H3.01172V7.91504Z",
    fill: "#EF9900"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01172 7.91504V7.91504C5.87739 8.59686 8.25052 10.3696 9.01172 12.415L8.25052 9.18777C8.1162 8.64231 7.66844 8.32413 7.1759 8.32413L3.01172 7.91504Z",
    fill: "#EF9900"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01172 7.91504V7.91504C5.87739 8.59686 8.25052 10.3696 9.01172 12.415L8.47441 10.6423C8.34008 10.0969 8.16097 9.5514 7.53411 9.32413L3.01172 7.91504Z",
    fill: "#EF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.72fb4677b1cda6105564cb93c4b64888.svg";
export { ForwardRef as ReactComponent };